import { Toaster as SonnerToaster } from "sonner";

import styles from "./Toaster.module.css";

const DEFAULT_DURATION = 4000;

export const Toaster = () => {
  return (
    <SonnerToaster
      position="bottom-right"
      theme="dark"
      gap={8}
      toastOptions={{
        className: styles.toast,
        duration: DEFAULT_DURATION,
      }}
    />
  );
};
